// UGC ファネル（収集→公開→効果）
// 対応ルーター: backend/routers/ugc_analytics.py の /ugc/analytics/funnel

/**
 * クエリはパスに書かない。`{month}` のようにテンプレートを埋めておくと、
 * **未指定の項目が置換されずそのまま送られて** `month={month}` になり、
 * サーバが 422 を返す。422 は SWR がリトライしない種類のエラーなので、
 * 画面は「読み込み中」のまま永久に止まる（実際に月表示・年度表示の両方で発生した）。
 * 任意項目は vars に入れておけば、fetcher が undefined を落としてクエリを組み立てる。
 */
export const UGCFunnelApiPath = {
  GET_FUNNEL: '/api/sites/{site_id}/ugc/analytics/funnel'
} as const

export interface GetFunnelVars {
  site_id: number
  days: number
  /** YYYY-MM（JST）。指定時は days より優先 */
  month?: string
  /** 年度（4月〜翌3月・JST）。month より優先 */
  fiscal_year?: number
}

/**
 * 率が null のときは「母数が0でまだ測れていない」。0% とは意味が違うので、
 * 画面では 0% ではなく「—」を出すこと。
 */
export interface FunnelResponse {
  period_days: number
  collect: {
    requests: number
    sent: number
    opened: number
    clicked: number
    submitted: number
    open_rate: number | null
    click_rate: number | null
    submit_rate: number | null
  }
  curate: {
    reviews: number
    published: number
    awaiting: number
    publish_rate: number | null
  }
  impact: {
    impressions: number
    clicks: number
    purchases: number
    revenue: number
    ctr: number | null
    cvr: number | null
  }
}
